import { client } from 'lib/evi-api-gateway';

import * as mc_questionTypes from 'types/mc_question';

const mc_question = `${process.env.REACT_APP_API_URL_RESOURCE}/api/item/mc_question`;

export async function get_qa_full_list(params: mc_questionTypes.get_qa_full_list_params) {
  return client.post({
    url: `${mc_question}/get_qa_full_list`,
    form: {
      ...params
    }
  });
}

export async function get_mc_answer_options(params: mc_questionTypes.get_mc_answer_options_params) {
  return client.post({
    url: `${mc_question}/get_mc_answer_options`,
    form: {
      ...params
    }
  });
}

export async function quick_set_list() {
  return client.post({
    url: `${mc_question}/get_topic_list`,
    form: {}
  });
}

export async function get_question_list(params: mc_questionTypes.get_question_list_params) {
  return client.post({
    url: `${mc_question}/get_question_list`,
    form: {
      ...params
    }
  });
}

// 匹配ai數據
export async function get_excel_search(params: any) {
  return client.post({
    url: `${mc_question}/get_excel_search`,
    form: {
      ...params
    }
  });
}
